var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.55027 0.934967C2.33264 0.993196 2.22268 1.08347 1.58141 1.73025C0.92157 2.39576 0.869618 2.46304 0.822523 2.71298C0.807954 2.7903 0.80032 4.37639 0.80032 7.32515C0.80032 12.3304 0.786868 11.9058 0.94935 12.0297C0.999457 12.0679 1.06072 12.0887 1.12374 12.0887L5.11332 12.0943L8.19868 12.0985C8.7515 12.0993 9.20006 11.6513 9.20006 11.0985V7.19988V3.29986C9.20006 2.74757 8.75235 2.29986 8.20006 2.29986H5.59653H1.99297L2.34246 1.94987L2.69195 1.59988H6.29598H9.40004C9.67618 1.59988 9.90004 1.82374 9.90004 2.09988V6.14974V10.3496C9.90004 10.5429 10.0567 10.6996 10.25 10.6996C10.4433 10.6996 10.6 10.5429 10.6 10.3496V5.79975V1.90027C10.6 1.34784 10.1521 0.900065 9.59965 0.900267L6.6353 0.901346C3.21748 0.902593 2.65397 0.90723 2.55027 0.934967Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.7c51314d.svg";
export { ForwardRef as ReactComponent };